var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-avatar", {
        ref: "vueavatar",
        attrs: {
          width: _vm.width,
          height: _vm.height,
          rotation: _vm.rotation,
          borderRadius: _vm.borderRadius,
          border: _vm.border,
          color: _vm.color,
          scale: _vm.scale,
        },
        on: {
          "vue-avatar-editor:image-ready": _vm.onImageReady,
          "select-file": function ($event) {
            return _vm.onSelectFile($event)
          },
        },
      }),
      _c("br"),
      _vm.hasScale
        ? _c("label", [
            _vm._v(" Zoom : " + _vm._s(_vm.scale) + "x "),
            _c("br"),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.scale,
                  expression: "scale",
                },
              ],
              attrs: { type: "range", min: "1", max: "3", step: "0.02" },
              domProps: { value: _vm.scale },
              on: {
                __r: function ($event) {
                  _vm.scale = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _c("br"),
      _vm.hasRotation
        ? _c("label", [
            _vm._v(" Rotation : " + _vm._s(_vm.rotation) + "° "),
            _c("br"),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.rotation,
                  expression: "rotation",
                },
              ],
              attrs: { type: "range", min: "0", max: "360", step: "1" },
              domProps: { value: _vm.rotation },
              on: {
                __r: function ($event) {
                  _vm.rotation = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _c("br"),
      _c("button", { on: { click: _vm.finished } }, [
        _vm._v(_vm._s(_vm.finishText)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }